import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteJobRecruitmentApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-job-recruitment'
  }
}